export default "__VITE_ASSET__DEjZ8nvt__"